module.exports = __webpack_public_path__ + "media/images/views/client/home/banner-pc-4cc3fa1e792ffb1be84ee175527b5c62.png";